export function normalizeTeam(teamJson) {
  return {
    formation: teamJson.formationUsed,
    players: teamJson.player.map(p => ({
      id: p.playerId,
      name: p.matchName,
      position: p.position,
      side: p.positionSide,
      shirtNumber:p.shirtNumber,
      formationPlace: p.formationPlace
        ? Number(p.formationPlace)
        : null,
      isSubstitute: p.position === "Substitute"
    }))
  };
}
